import { BaseMedicalInsuranceConfig } from 'freedom-shared';

export const DETAILS_BOTTOM_SHEET = 'medical-insurance-details';
export const CONDITIONS_BOTTOM_SHEET = 'medical-insurance-conditions';
export const FORM_BOTTOM_SHEET = 'medical-insurance-form-bottom-sheet';
export const END_DATE_BOTTOM_SHEET = 'medical-insurance-end-date-bottom-sheet';
export const SUM_BOTTOM_SHEET = 'medical-insurance-sum-bottom-sheet';
export const PUBLIC_OFFER_BOTTOM_SHEET =
  'medical-insurance-public-offer-bottom-sheet';

export const medicalInsuranceConfig = {
  ...BaseMedicalInsuranceConfig,
  DETAILS_BOTTOM_SHEET,
  CONDITIONS_BOTTOM_SHEET,
  FORM_BOTTOM_SHEET,
  END_DATE_BOTTOM_SHEET,
  SUM_BOTTOM_SHEET,
  PUBLIC_OFFER_BOTTOM_SHEET,
};
